import React, { Component } from "react";
import { connect } from "react-redux";
import Dashboard from "../Dashboard/Dashboard";
import Heading from "../../AdminPanel/Component/UI/Heading";
import AddButton from "../../AdminPanel/Component/UI/AddButton";
import SearchBox from "../../AdminPanel/Component/UI/SearchBox";
import CommonTableTeam from "../../AdminPanel/Component/UI/CommonTableTeam";
import Tooltip from "../../AdminPanel/Component/UI/Tooltip";
import AddTeamModal from "./Component/AddTeamModal";
import UpdateTeamModal from "./Component/UpdateTeamModal";

import AddCampaignsModal from "./Component/AddCampaignsModal";

import { MdSearch, MdArrowForwardIos, MdArrowBackIos } from "react-icons/md";
import { LuUsers, LuUserCheck, LuDownload } from "react-icons/lu";
import { HiOutlineHome, HiMiniPlus } from "react-icons/hi2";
import { AiOutlineFileText, AiOutlineUsergroupAdd } from "react-icons/ai";
import { TbUsersPlus } from "react-icons/tb";
import { SlReload } from "react-icons/sl";
import { FiEdit, FiSend } from "react-icons/fi";
import { RiDeleteBinLine } from "react-icons/ri";
import { assessmentActions, userActions } from "../../../_actions";
import DeleteTeamModal from "./Component/DeleteTeamModal";
import moment from 'moment';
import LoadingOverlay from 'react-loading-overlay';
import { BsBarChartLine } from "react-icons/bs";
import ProgressTab from "../Component/ProgressTab";


class AdminPanel extends Component {

  constructor(props) {
    super(props);
    this.state = {
      showDeleteConfirmId: "",
      addUserModal: false,
      updateUserModal: false,
      entries: 20,
      updateForm: {
        id: "",
        name: "",
        email: "",
        mobile: ""
      },
      pageNo: 1,
      size: 10,
      keyWord: "",
      addCampaignsModal: false,

      campformData: {
        title: "",
        subject: "",
        message: "",
        teamId: "",
        assessment: "644abb4b1236ff3f408634d1",
        productList: ["644abb4b1236ff3f408634d1"],
        type: "team",
        list: [],
        stage: 1
      },
      crrCodeObj: {
        id: "", title: "", count: 0
      }
    };
  }

  componentDidMount() {
    this.props.dispatch(assessmentActions.userAssessmentUserProfile());
    this.props.dispatch(assessmentActions.getAvailableCodeCount());

    const temp = {
      keyWord: "",
      pageNo: 1,
      size: 10
    }
    this.props.dispatch(assessmentActions.getTeamList(temp));
    this.callUserListAPI();
  }


  openAddTeamModal = () => {
    console.log("Opening Add User Modal");
    this.setState({ addUserModal: true }, () => {
      console.log("Modal state updated:", this.state.addUserModal);
    });
  };

  closeAddTeamModal = () => {
    console.log("Closing Add User Modal");
    this.setState({ addUserModal: false });
  };

  // Handle entries dropdown change
  handleEntriesChange = (value) => {
    this.setState({ entries: value });
  };

  onAddUser = (data) => {
    console.log("data--------///------->", data)
    const temp = {
      keyWord: "",
      pageNo: 1,
      size: 10
    }
    this.props.dispatch(assessmentActions.createNewTeam(data, temp));
    this.closeAddTeamModal();
  };

  handleUpdateChange = (e) => {
    let { updateForm } = this.state;
    updateForm[e.target.name] = e.target.value;
    this.setState({ updateForm });
  }

  closeUpdateTeamModal = () => {
    console.log("Closing Update User Modal");
    this.setState({ updateUserModal: false });
  };

  onEditUser = (data) => {
    let temp = {
      id: data.teamId,
      name: data.teamname
    }
    this.setState({ updateForm: temp, updateUserModal: true });
  }

  onUpdateUser = (data) => {
    const temp = {
      keyWord: "",
      pageNo: 1,
      size: 10
    }
    this.props.dispatch(assessmentActions.updateTeam(data, temp));
    this.closeUpdateTeamModal();
  };

  // Close modal
  closeUpdateTeamModal = () => {
    this.setState({ updateUserModal: false });
  };

  // Reupload handler
  handleReupload = () => {
    console.log("Reupload clicked");
    this.setState({ updateUserModal: false });
  };

  onSelectTeam = (team) => {
    this.props.history.push(`/assessment/myteamdetails/` + team.teamId);
  }

  // Open delete modal
  onDeleteConfirm = (row) => {
    this.setState({ showDeleteConfirmId: row.teamId });
  };

  // Close delete modal
  closeDeleteConfirm = () => {
    this.setState({ showDeleteConfirmId: "" });
  };

  // submit delete modal
  submitDeleteConfirm = () => {
    let data = {
      id: this.state.showDeleteConfirmId
    }
    const temp = {
      keyWord: "",
      pageNo: 1,
      size: 10
    }
    this.props.dispatch(assessmentActions.deleteMyTeam(data, temp));
    this.closeDeleteConfirm();
  };

  callUserListAPI = () => {
    const { pageNo, size, keyWord } = this.state;
    this.props.dispatch(
      assessmentActions.getTeamList({
        pageNo,
        size,
        keyWord
      })
    );
  };

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState.pageNo !== this.state.pageNo ||
      prevState.size !== this.state.size ||
      prevState.keyWord !== this.state.keyWord
    ) {
      this.callUserListAPI();
    }
  }

  handleSearch = (event) => {
    event.preventDefault();
    let { value } = event.target;
    this.setState({ keyWord: value, offset: 0 });
    let data = {
      "keyWord": value,
      "pageNo": this.state.pageNo,
      "size": this.state.size
    }
    this.props.dispatch(assessmentActions.getTeamList(data));
  }

  handleSizeChange = (e) => {
    this.setState({
      size: Number(e.target.value),
      pageNo: 1
    });
  };

  goPrev = () => {
    this.setState((prev) => ({
      pageNo: Math.max(prev.pageNo - 1, 1)
    }));
  };

  goNext = () => {
    const { getMyUserListTotal } = this.props.assessment;
    const totalPages = Math.ceil(getMyUserListTotal / this.state.size);
    this.setState((prev) => ({
      pageNo: Math.min(prev.pageNo + 1, totalPages)
    }));
  };

  logout = () => {
    this.props.dispatch(assessmentActions.AssessmentUserLogout(this.props));
  };

  switchToSelf = () => {
    this.props.dispatch(userActions.userCoachSwitchLogin({}, this.props));
  };

  onSendUser = (data) => {
    let { campformData } = this.state;
    campformData["teamId"] = data.teamId;
    this.setState({ campformData, crrTeamId: data.teamId, addCampaignsModal: true }, () => {
      this.props.dispatch(assessmentActions.getAssessmentProducts());
      const temp = {
        teamId: data.teamId,
        keyWord: "",
        pageNo: 1,
        size: 10
      }
      this.props.dispatch(assessmentActions.getMyUserList(temp));
    });
  }

  handleCampaignInput = (e, save) => {
    let { campformData } = this.state;
    let name = e.target.name;
    let value = e.target.value;

    let title = e.target.title;
    let count = e.target.count;

    if (save === 2) {
      console.log("e-----x----->", e)
    }

    if (name === "type" || name === "teamId") {
      campformData[name] = value.value;
    } else {
      campformData[name] = value;
    }
    if (save === 2) {
      this.setState({ crrCodeObj: { id: value, title: title, count: count } })
    }

    this.setState({ campformData })
  }


  handleProductSelect = (pId) => {
    this.setState((prevState) => {
      const productList = prevState.campformData.productList || [];
      const updatedProductList = productList.includes(pId)
        ? productList.filter((id) => id !== pId) // Remove if exists
        : [...productList, pId];                 // Add if not

      return {
        campformData: {
          ...prevState.campformData,
          productList: updatedProductList
        },
      };
    });
  };


  closeAddCampaignsModal = (type) => {
    if (type === "prev") {
      let { campformData } = this.state;
      this.setState({ campformData: { ...campformData, stage: 1 } });
    } else {
      this.setState({ addCampaignsModal: false });

    }
  };

  onSubmitForm = (codeInitobj) => {
    let { campformData, crrCodeObj } = this.state;
    if (campformData && campformData.teamId) {
      this.setState({ campformData: { ...campformData, stage: 2 } });
      if (!(crrCodeObj && crrCodeObj.id)) {
        this.setState({ crrCodeObj: codeInitobj });
      }
    }
  }

  onSubmit = () => {
    let { campformData } = this.state;
    const data = {
      title: "Campaign_" + moment().format("DD_MM_YYYY_HH_mm"),
      subject: campformData?.subject ?? "",
      message: campformData?.message ?? "",
      list: campformData?.list ?? [],
      productList: campformData?.productList ?? [],
      // productId: campformData?.assessment ?? "",
      teamId: campformData?.teamId ?? null,
      type: campformData?.type ?? ""
    };

    const temp = {
      "keyWord": "",
      "pageNo": 1,
      "size": 10
    }
    this.props.dispatch(assessmentActions.saveCoachCampaign(data, temp));

    setTimeout(() => {
      this.setState({
        addCampaignsModal: false,
        campformData: {
          title: "",
          subject: "",
          message: "",
          teamId: "",
          assessment: "644abb4b1236ff3f408634d1",
          productList: ["644abb4b1236ff3f408634d1"],
          type: "team",
          list: [],
          stage: 1
        }
      });
    }, 500)

  }

  onSelectionChange = (value) => {
    let { campformData } = this.state;
    this.setState({ campformData: { ...campformData, list: value } });
  }

  onResponses = (data) => {
    this.props.history.push(`/assessment/myteamdetails/` + data.teamId);
  }

  render() {
    let { assessment } = this.props;
    let { showDeleteConfirmId, pageNo, size, addCampaignsModal, campformData, crrCodeObj } = this.state;
    let { userAssessmentUserProfileData, getTeamListData, getTeamListTotal,
      getMyUserListData, getMyUserListTotal, getAssessmentProductsData, getAvailableCodeCountData,
    } = assessment;

    let data = getTeamListData && getTeamListData.length > 0 ? getTeamListData.map((ele, i) => ({
      id: i + 1,
      teamId: ele.id,
      teamname: ele.name,
      teammembers: ele.count,
      status: ele.isComplete ? "Completed" : "Pending"
    })) : [];

    const { addUserModal, updateUserModal, entries } = this.state;
    const columns = [
      { key: "id", label: "S.No." },
      { key: "teamname", label: "Team Name" },
      { key: "teammembers", label: "Team Members" },
    ];

    const start = getTeamListTotal === 0 ? 0 : (pageNo - 1) * size + 1;
    const end = Math.min(pageNo * size, getTeamListTotal);
    const totalPages = Math.ceil(getTeamListTotal / size);

    const getPeriod = () => {
      const hour = moment().hour(); // 0–23
      if (hour >= 5 && hour < 12) return "Morning";
      if (hour >= 12 && hour < 17) return "Afternoon";
      if (hour >= 17 && hour < 21) return "Evening";
      return "Night";
    };
    let userDetails = {
      name: userAssessmentUserProfileData?.name ?? "",
      email: userAssessmentUserProfileData?.email ?? "",
      period: getPeriod()
    };

    let { loading } = assessment;

    return (
      <Dashboard userDetails={userDetails} logout={this.logout} switchToSelf={this.switchToSelf} loading={loading}>
        <div className="p-8 min-h-screen">

          <ProgressTab currentStep={3} history={this.props.history} />
          <div className="border-b border-slate-300" />

          <div className="flex items-center justify-between py-5">
            <div className="flex items-center gap-3">
              <Heading className="text-2xl font-bold text-gray-900" title="My Teams" />
            </div>
            <div className="flex items-center gap-3">
              <AddButton title="Create New Team" Icon={HiMiniPlus} className="bg-gradient-to-r from-[#673AB7] to-[#1976D2] text-white"
                onClick={this.openAddTeamModal} />
            </div>
          </div>



          {/* Table Section*/}
          <div className="overflow-x-auto bg-white border rounded-md p-4">
            <div className="flex justify-between items-center mb-4">
              <div className="flex items-center gap-2 text-sm textblack">
                Show
                <select value={this.state.size} onChange={this.handleSizeChange} className="border rounded-md px-2 py-1">
                  <option value={10}>10</option>
                  <option value={20}>20</option>
                  <option value={50}>50</option>
                </select>
                entries
              </div>

              <div className="flex items-center gap-3 text-sm textblack">
                <div className="">
                  <SearchBox
                    value={this.state.keyWord}
                    onChange={this.handleSearch}
                    placeholder="Search"
                  />
                </div>
                <div>{start}-{end} of {getTeamListTotal}</div>
                <div onClick={this.goPrev} disabled={this.state.pageNo === 1} className={`p-2 rounded-md ${this.state.pageNo === 1 ? "opacity-40 cursor-not-allowed" : "bglightcolor textcolor"}`}>
                  <MdArrowBackIos size={20} />
                </div>
                <div onClick={this.goNext} disabled={this.state.pageNo === totalPages} className={`p-2 rounded-md ${this.state.pageNo === totalPages ? "opacity-40 cursor-not-allowed" : "bglightcolor textcolor"}`}>
                  <MdArrowForwardIos size={20} />
                </div>
              </div>
            </div>

            <CommonTableTeam
              columns={columns}
              onClick={this.onSelectTeam}
              data={data}
              renderActions={(row) => (
                <div className="flex gap-2">
                  <Tooltip text="Edit" position="top">
                    <div onClick={() => this.onEditUser(row)} className="p-2 cursor-pointer rounded bg-gray-100 text-black hover:bg-blue-100 hover:text-blue-600"><FiEdit size={18} /></div>
                  </Tooltip>
                  <Tooltip text="Delete" position="top">
                    <div onClick={() => this.onDeleteConfirm(row)} className="p-2 cursor-pointer rounded bg-gray-100 text-black hover:bg-red-100 hover:text-red-600 hover:bg-red-200"><RiDeleteBinLine size={18} /></div>
                  </Tooltip>
                </div>
              )}

              renderCampaign={(row) => (
                <div className="flex gap-2">
                  <Tooltip text="Send" position="top">
                    <div onClick={() => this.onSendUser(row)} className="p-2 cursor-pointer rounded bg-gray-100 text-black hover:bg-blue-100 hover:text-blue-600"><FiSend size={18} /></div>
                  </Tooltip>
                  <Tooltip text="Status" position="top">
                    <div onClick={() => this.onResponses(row)} className="p-2 cursor-pointer rounded bg-gray-100 text-black hover:bg-blue-100 hover:text-blue-600"><BsBarChartLine size={18} /></div>
                  </Tooltip>
                </div>
              )}


            />

            {this.state.keyWord ?
              <>
                {!loading && !(data && data.length > 0) &&
                  <div className="flex items-center justify-center">
                    <div className="text-center py-8">
                      <div className="flex flex-col items-center justify-center text-gray-500">
                        <h1 className="text-lg font-semibold">No Data Found</h1>
                        <p className="text-sm mt-1">Try adjusting your search or filters</p>
                      </div>
                    </div>
                  </div>
                }
              </> :
              <>
                {!loading && !(data && data.length > 0) &&
                  <div className="bg-gradient-to-b from-teal-50 to-white border rounded-xl min-h-[520px] flex flex-col items-center justify-center text-center space-y-6">
                    <div className="w-20 h-20 rounded-full bg-white border-4 border-[#E0F2F1] flex items-center justify-center">
                      <AiOutlineUsergroupAdd size={40} className="textcolor" />
                    </div>
                    <div className="space-y-1">
                      <h3 className="text-lg font-semibold">Add your first team to continue.</h3>
                    </div>
                    <AddButton title="Create New Team" Icon={HiMiniPlus} onClick={() => this.openAddTeamMemberModal()} className="bgcolor text-white" />
                  </div>
                }

              </>}

          </div>

        </div>

        <div className="sticky bottom-0 left-0 right-0 bg-white/90 backdrop-blur-md border-t border-gray-200 py-4 px-6 flex items-center justify-between z-10">
          <button onClick={() => this.props.history.goBack()} className="px-8 py-2 rounded-md bg-gray-100 hover:bg-gray-200 text-gray-500 font-semibold text-base transition-colors duration-200">  Back</button>
          <button onClick={() => this.props.history.push("/assessment/myresults")} className="px-5 py-2 rounded-md bg-gradient-to-r from-[#673AB7] to-[#1976D2] text-white font-semibold text-base transition-colors duration-200 shadow-md shadow-indigo-100">Continue to Step 4</button>
        </div>


        {addCampaignsModal && (
          <AddCampaignsModal
            productList={getAssessmentProductsData}
            // teamList={getTeamListData}
            codeCountList={getAvailableCodeCountData}
            getMyUserListData={getMyUserListData}
            formData={campformData}
            handleChange={this.handleCampaignInput}
            handleProductSelect={this.handleProductSelect}
            onSubmitForm={this.onSubmitForm}
            onSubmit={this.onSubmit}

            onClose={this.closeAddCampaignsModal}
            onSelectionChange={this.onSelectionChange}
            crrCodeObj={crrCodeObj}
          />
        )}


        {addUserModal && (
          <AddTeamModal onClose={this.closeAddTeamModal} onSubmit={this.onAddUser} />
        )}

        {updateUserModal && (
          <UpdateTeamModal onClose={this.closeUpdateTeamModal} updateForm={this.state.updateForm} handleUpdateChange={this.handleUpdateChange} onSubmit={this.onUpdateUser} />
        )}

        {showDeleteConfirmId && (
          <DeleteTeamModal onClose={this.closeDeleteConfirm} onSubmit={this.submitDeleteConfirm} />
        )}


      </Dashboard>
    );
  }
}

function mapStateToProps(state) {
  //console.log("state  ", state);
  const { loggingIn } = state.authentication;
  const { assessment } = state;
  return {
    loggingIn,
    assessment
  };
}

export default connect(mapStateToProps)(AdminPanel);


